import React from 'react';
import { Route } from '@/navigation/Route';
import { ProducerFeeScreen } from './screens';

export const PRODUTCER_FEE_ROUTES = {
  itself: '/dashboard/producer-fee',
};

export const ProducerFeeNavigation = (): JSX.Element => (
  <Route exact path={PRODUTCER_FEE_ROUTES.itself} component={ProducerFeeScreen} isPrivateRoute />
);
